import { ChatSituations } from '../../../../../../../../utils/fuctions/mapSituationChat';

export const spotStyle = (type) => {
  switch (type) {
    case ChatSituations.IN_ATTENDANCE:
      return {
        name: 'EM ATENDIMENTO',
        color: '#5cb85c',
        icon: 'far fa-bell',
        iconColor: 'white'
      };
    case ChatSituations.TRANSFERRED:
      return {
        name: 'TRANSFERIDA',
        color: '#f7f7f7',
        icon: 'fas fa-external-link-alt',
        iconColor: '#999999'
      };
    case ChatSituations.TO_ANSWER:
      return {
        name: 'ATENDER',
        color: '#5bc0de',
        icon: 'fas fa-sign-in-alt',
        iconColor: 'white'
      };
    case ChatSituations.HANGED_UP:
      return {
        name: 'ENCERRADA',
        color: '#d9534f',
        icon: 'fas fa-check',
        iconColor: 'white'
      };
    case ChatSituations.NOT_ANSWERED:
      return {
        name: 'NÃO ATENDIDA',
        color: '#d9534f',
        icon: 'fas fa-times',
        iconColor: 'white'
      };
    case ChatSituations.ABANDONED:
      return {
        name: 'ABANDONADA',
        color: '#d9534f',
        icon: 'fas fa-times',
        iconColor: 'white'
      };
    case ChatSituations.REDISTRIBUTED:
      return {
        name: 'REDISTRIBUIDA',
        color: '#d9534f',
        icon: 'fas fa-times',
        iconColor: 'white'
      };
    default:
      return {
        name: 'INDEFINIDO',
        color: '#f7f7f7',
        icon: 'fas fa-question',
        iconColor: '#999999'
      };
  }
};
